import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getDataSourceEnum: build.query({
      query: () => ({ url: `/data-source-enum` }),
      providesTags: ['data-source-enum-options'],
      transformResponse: (response) => response
    }),

    // Opções de um filtro qualquer, buscadas na URL vinda dos metadados
    // (data_source_column.filter_source_url). Genérico p/ qualquer fonte
    getFilterOptions: build.query({
      query: (url) => ({ url, params: { todos: false } }),
      transformResponse: (response) => response
    }),

    // Opções (value/description) resolvidas da fonte de dados de um campo.
    getFieldDataSourceOptions: build.query({
      query: ({ fieldId }) => ({ url: `/action-custom-fields/field/${fieldId}/data-source-options` }),
      transformResponse: (response) => response || []
    })
  })
})

export const { useGetDataSourceEnumQuery, useGetFilterOptionsQuery, useGetFieldDataSourceOptionsQuery } = api
